import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=ca3b0478&"
import script from "./Teacher.vue?vue&type=script&lang=ts&"
export * from "./Teacher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports